import FileSaver from 'file-saver';
import { License } from '../../api/api-generated';
import { useFindAllHardwareQuery } from '../../api/api-hooks';
import { getLicenseName } from './licenseUtils';

export const useAdminDownloadSpectrasLicenses = () => {
  const { data: allHardware } = useFindAllHardwareQuery({});
  const serialMap = new Map<number, string>();
  if (allHardware === undefined) return;
  for (const hardware of allHardware) {
    serialMap.set(hardware.id, hardware.serial);
  }
  return (licenses: License[], companyName: string) => {
    const licenseMap = new Map<
      string,
      { serial: string; modules?: string[]; license?: string }
    >();
    for (const license of licenses) {
      // Get serial associated with license, and if none, use NA as a string placeholder
      const serialOrNothing = serialMap.get(license.hardwareId);
      const serial = serialOrNothing ? serialOrNothing : 'NA';
      // Find whether you've previously seen a license associated with this license's serial
      const existingLicense = licenseMap.get(serial);
      // If you haven't seen a previous license, add a new serial/license pair to the map
      if (!existingLicense) {
        if (license.moduleId) {
          licenseMap.set(serial, { serial, modules: [license.license] });
        } else {
          licenseMap.set(serial, {
            serial,
            license: license.license,
            modules: [],
          });
        }
        // If you have seen a previous license, combine this and the previous license(s)
      } else {
        if (license.moduleId) {
          if (existingLicense.modules) {
            licenseMap.set(serial, {
              ...existingLicense,
              modules: [...existingLicense.modules, license.license],
            });
          } else {
            licenseMap.set(serial, {
              ...existingLicense,
              modules: [license.license],
            });
          }
        } else {
          licenseMap.set(serial, {
            ...existingLicense,
            license: license.license,
          });
        }
      }
    }
    // Convert map into array of objects
    const licenseBody: {
      serial: string;
      license?: string;
      modules?: string[];
    }[] = [];
    licenseMap.forEach((value, key) => {
      licenseBody.push(value);
    });
    const licenseName = getLicenseName(companyName, 'Spectras');
    // Download licenses
    const fileBlob = new Blob([JSON.stringify(licenseBody)], {
      type: 'text/plain;charset=utf-8',
    });
    FileSaver.saveAs(fileBlob, licenseName);
  };
};
